import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// utils
import axios, { fetcher } from '@utils/axios';

const initialState = {
  modal: false
};

const endpoints = {
  key: 'api',
  list: '/categories', // server URL
  modal: '/modal', // server URL
  insert: '/insert', // server URL
  update: '/update', // server URL
  delete: '/delete' // server URL
};

export function useGetCategories() {
  const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.list, fetcher, {
    revalidateIfStale: true, // always revalidate if cache is stale
    revalidateOnFocus: false, // don’t revalidate when tab is focused
    revalidateOnReconnect: true, // revalidate when reconnecting network
    revalidateOnMount: true,
    dedupingInterval: 0
  });

  const memoizedValue = useMemo(
    () => ({
      customers: data?.result,
      customersLoading: isLoading,
      customersError: error,
      customersValidating: isValidating,
      customersEmpty: !isLoading && !data?.result?.length
    }),
    [data, error, isLoading, isValidating]
  );
  return memoizedValue;
}

export async function insertCustomer(newCustomer) {
  try {
    const { status, data } = await axios.post(endpoints.key + endpoints.list, newCustomer);
    if (status && status >= 400 && status <= 599) {
      return;
    }
    mutate(
      endpoints.key + endpoints.list,
      (currentCustomer) => {
        const addedCustomer = [...currentCustomer.result, data.result];

        return {
          ...currentCustomer.result,
          result: addedCustomer
        };
      },
      false
    );
  } catch (error) {
    return error;
  }
}

export async function updateCustomer(customerId, updatedCustomer) {
  try {
    const url = `${endpoints.key}${endpoints.list}/${customerId}`;
    const { status, data } = await axios.put(`${url}`, updatedCustomer);
    if (status && status >= 400 && status <= 599) {
      return;
    }
    mutate(
      endpoints.key + endpoints.list,
      (currentCustomer) => {
        const newCustomer = currentCustomer.result.map((customer) =>
          customer.id === customerId ? { ...customer, ...updatedCustomer } : customer
        );

        return {
          ...currentCustomer.result,
          result: newCustomer
        };
      },
      false
    );
  } catch (error) {
    return error;
  }
}

export async function deleteCustomer(customerId) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer) => {
      const nonDeletedCustomer = currentCustomer.result.filter((customer) => customer.id !== customerId);

      return {
        ...currentCustomer,
        result: nonDeletedCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  await axios.delete(`${endpoints.key}${endpoints.list}/${customerId}`);
}

export function useGetCustomerMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.modal, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      customerMaster: data,
      customerMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerCategoryDialog(modal) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.modal,
    (currentCustomermaster) => {
      return { ...currentCustomermaster, modal };
    },
    false
  );
}
